module.exports = require("./ff-Latn-BF.d.ts");